import React, { FC, useLayoutEffect } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import { useAssessmentPortalState } from '../../../assessment-portal';
import type { AdhdQuestionnaireFlowState } from '../../types/flow';
import { AdhdQuestionnaireFlowStep } from '../../data/constants';
import CompletionPage from '../completion-page';

const QuestionnaireCompletionStep: FC<StepPageProps> = () => {
  const { flowState, goToStep } = useAssessmentPortalState<AdhdQuestionnaireFlowState>();
  const completionData = flowState.completionDisplay;

  useLayoutEffect(() => {
    if (!completionData) {
      goToStep(AdhdQuestionnaireFlowStep.ASSESSMENT_INTRO);
    }
  }, [completionData, goToStep]);

  if (!completionData) {
    return null;
  }

  return (
    <CompletionPage
      variant="all-done"
      isSuccess
      firstName={completionData.firstName}
      clinicianName={completionData.clinicianName}
      clinicianTitle={completionData.clinicianTitle}
      startDateTime={completionData.startDateTime}
    />
  );
};

export default QuestionnaireCompletionStep;
